export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "Sicela ufake umbhalo wakho lapha",
      conversationalPlaceholder: "Sicela ufake impendulo yakho lapha",
      conversationClosed: "Ingxoxo ivaliwe.",
      conversationalDisclaimer: "Imibuzo elandelayo izokhiqizwa yi-AI ngokusekelwe ezimpendulweni zakho."
    },
    openText: {
      openEndPlaceholder: "Sicela ufake umbhalo wakho lapha"
    },
    multiText: {
      fieldPlaceholder: 'Impendulo {number}',
      instruction: 'Thayipha okungenani impendulo engu-{count} ngezansi, eyodwa ebhokisini ngalinye lombhalo | Thayipha okungenani izimpendulo ezingu-{count} ngezansi, eyodwa ebhokisini ngalinye lombhalo',
      instructionWithoutMinimum: 'Thayipha izimpendulo zakho ngezansi, eyodwa ebhokisini ngalinye lombhalo',
      minimumEntries: 'Sicela ufake okungenani impendulo engu-{count} ukuze uqhubeke. | Sicela ufake okungenani izimpendulo ezingu-{count} ukuze uqhubeke.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'Ibhrendi {number}',
        minimumEntries: 'Sicela ufake okungenani ibhrendi elingu-{count} ukuze uqhubeke. | Sicela ufake okungenani amabhrendi angu-{count} ukuze uqhubeke.'
      }
    },
    multiselect: {
      caption: "Khetha konke okusebenzayo"
    },
    rankOrder: {
      enterRankOrder: "Faka ukuhleleka kwezinto",
      placeholder: "Hudula okukhethile lapha ukuze uhlele"
    },
    openNumeric: {
      label: "Inombolo evulekile"
    },
    complete: {
      message: "Siyabonga ngokugcwalisa lolu cwaningo."
    },
    openVideo: {
      warning: "Sicela uqophe ividiyo ngaphambi kokuba uqhubeke.",
      uploadStatusUploading: "Sicela ulinde size siqede ukucubungula ividiyo yakho ngaphambi kokuqhubeka...",
      uploadStatusSuccess: "Ukulayishwa kuphumelele, ungaqhubeka.",
      uploadStatusError: "Ukulayishwa aluqedwanga, sicela uzame futhi."
    }
  },
  errors: {
    node: {
      text_invalid_email: 'Sicela ufake i-imeyili evumelekile',
      text_invalid_phone: 'Sicela ufake inombolo yefoni evumelekile',
      text_invalid_us_zip: 'Sicela ufake i-US ZIP evumelekile',
      text_invalid_ca_postal: 'Sicela ufake ikhodi yeposi yase-Khanada evumelekile',
      text_invalid_uk_postal: 'Sicela ufake ikhodi yeposi yase-UK evumelekile',
      text_invalid_custom: 'Sicela ufake {fieldName} evumelekile',
      text_min_chars: 'Sicela ufake okungenani ongu-{min} wezinhlamvu',
      text_max_chars: 'Sicela ungafaki izinhlamvu ezingaphezu kwe-{max}',
      text_alpha_not_allowed: 'Izinombolo kuphela ezivunyelwe',
      text_numeric_not_allowed: 'Ozinhloko zezinhlamvu kuphela ezivunyelwe'
    },
    external: {
      invalid: 'Impendulo yalo mbuzo ayivumelekile.',
      required: 'Lo mbuzo kufanele uphendulwe.',
      singlechoice_required: 'Sicela ukhethe inketho eyodwa ngaphambi kokuqhubeka.',
      numeric_required: 'Sicela ukhethe isilinganiso ngaphambi kokuqhubeka.',
      text_required: 'Sicela ufake impendulo ngaphambi kokuqhubeka.',
      bigtext_required: 'Sicela ufake impendulo ngaphambi kokuqhubeka.',
      singlechoiceother_incomplete: 'Sicela ufake impendulo ngaphambi kokuqhubeka.',
      multiselectother_incomplete: 'Sicela ufake impendulo ngaphambi kokuqhubeka.',
      numeric_invalid: 'Sicela ufake inombolo evumelekile ngaphambi kokuqhubeka.',
      radiogrid_required: 'Sicela ukhethe inketho kumugqa ngamunye ngaphambi kokuqhubeka.',
      incomplete: 'Sicela uwuqede ngokuphelele lo mbuzo ngaphambi kokuqhubeka.',
      multiselect_min: 'Sicela ukhethe okungenani izinketho ezingu-{value} ngaphambi kokuthi uqhubeke.',
      multiselect_max: 'Sicela ukhethe izinketho ezingaphezu kwezingu-{value} ngaphambi kokuthi uqhubeke.',
      multiselectother_min: 'Sicela ukhethe okungenani izinketho ezingu-{value} ngaphambi kokuthi uqhubeke.',
      multiselectother_max: 'Sicela ukhethe izinketho ezingaphezu kwezingu-{value} ngaphambi kokuthi uqhubeke.',
      multiselectgrid_min: 'Sicela ukhethe okungenani izinketho ezingu-{value} kumugqa ngamunye ngaphambi kokuqhubeka.',
      multiselectgrid_max: 'Sicela ukhethe izinketho ezingengaphezu kuka-{value} kumugqa ngamunye ngaphambi kokuthi uqhubeke.',
      rankorder_min: 'Sicela uhlukanise okungenani izinto ezingu-{value} ngaphambi kokuqhubeka.',
      rankorder_max: 'Sicela ungalinganisi izinto ezingaphezu kuka-{value} ngaphambi kokuthi uqhubeke.'
    }
  }
}
